export const defaultProductUi = {
  minusDisabled: true,
  plusDisabled: false,
  quantity: 1,
  fullPrice: 0.00,
  salePrice: 0.00,
  errors: [],
};

export function updateProductUi(product, newQuantity, productUi) {
  const {price, sale_price, retail_price, quantity_break_ranges, quantity_break_prices} = product;
  const parsedQuantity = parseInt(newQuantity, 10);

  let salePrice = sale_price || price;
  let fullPrice = retail_price || price;
  if ( quantity_break_ranges.length > 0) {
    for (let i = 0; i < quantity_break_ranges.length; i++) {
      const range = quantity_break_ranges[i].split("-");
      const lowerBound = parseInt(range[0], 10);
      const upperBound = parseInt(range[1], 10);
      // console.log(parsedQuantity, lowerBound, upperBound);
      if (
        (parsedQuantity >= lowerBound && parsedQuantity <= upperBound) ||
        (parsedQuantity >= lowerBound && isNaN(upperBound))
      ) {
        salePrice = quantity_break_prices[i];
        // console.log("salePrice: ", salePrice);
        break;
      } 
    }
  }

  const plusDisabled = (product.maximum_quantity !== null) && (parsedQuantity >= product.maximum_quantity);

  return {
    ...productUi,
    quantity: newQuantity,
    minusDisabled: parsedQuantity <= product.minimum_quantity,
    plusDisabled: plusDisabled,
    salePrice: parseFloat(salePrice),
    fullPrice: parseFloat(fullPrice),
  }
}